import React from "react";

const ContactPage = () => {
  return <div>Contact page</div>;
};

export default ContactPage;
